import { DemoIndicatorColoredIcon } from '@carboncopyco/icons';
import { Navbar } from '@carboncopyco/ui';
import { useEditor } from '../../context/EditorSdkProvider';

export const EditorNavbarRecordingTypeIcon = () => {
  const { recordingType } = useEditor();

  return (
    <Navbar.Icon
      label={recordingType === 'overlay' ? 'Live editor' : 'Editor'}
      icon={<DemoIndicatorColoredIcon size={30} />}
      bgColor="bg-ds-secondary-300"
    />
  );
};
